// extracted by mini-css-extract-plugin
export default {"root":"CustomToolbar_root__6+8Gz"};